import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function PageLoading({ message = 'Đang tải...' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f4f6f8'
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography
        variant="body1"
        sx={{
          mt: 3,
          color: 'text.secondary',
          fontWeight: 500
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}

